// extracted by mini-css-extract-plugin
export default {"container":"SignnedIn_container__TKICS","signOut":"SignnedIn_signOut__dJYJF","favourites":"SignnedIn_favourites__YWlvF","profileLogo":"SignnedIn_profileLogo__Z26wR"};